import { track } from "../track";

export const trackContentDislike = (params: { content_id: string; feedback: string }) =>
  track({ event: "content_dislike", ...params });
